import { render, staticRenderFns } from "./HomeEthBlocks.vue?vue&type=template&id=53e6d2f7&scoped=true"
import script from "./HomeEthBlocks.vue?vue&type=script&lang=js"
export * from "./HomeEthBlocks.vue?vue&type=script&lang=js"
import style0 from "./HomeEthBlocks.vue?vue&type=style&index=0&id=53e6d2f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e6d2f7",
  null
  
)

export default component.exports